import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


import dream from "../../Assets/Projects/dreamstore.png";
import aam from "../../Assets/Projects/aampower.png";
import dgarts from "../../Assets/Projects/dgarts.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dream}
              isBlog={false}
              title="DreamStore"
              description="Website designed for Food-based startup.It has various features like Shop using Location,Order Tracking, Stock Management, Multi-Language Shop.Built using Wordpress Theme"
              link="https://dreamstore.com.pk"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dgarts}
              isBlog={false}
              title="Digital Art's Studio"
              description="Website Designed For Photo Studio where users can browse studio's Portfolio, Services and also Book their projects Online.User can browse from Available Packages at the ease of their home.Website is build using HTML,CSS,Javascript,Django,MySQL"
              link="https://digitalartstudio.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aam}
              isBlog={false}
              title="AAMPOWER"
              description="This is one of my initial projects.It has designed using HTML,CSS,JS. It serves as showcase for auto-parts manufacturing company.Viewers can see services and products offered by the company.They can also contact the company for more information."
              link="https://aampower.netlify.app/"
            />
          </Col>

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Bits-0f-C0de"
              description="My personal blog page build with Next.js and Tailwind Css which takes the content from makdown files and renders it using Next.js. Supports dark mode and easy to write blogs using markdown."
              link="https://github.com/soumyajit4419/Bits-0f-C0de"
            />
          </Col> */}

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai For Social Good"
              description="Using 'Natural Launguage Processing' for the detection of suicide-related posts and user's suicide ideation in cyberspace  and thus helping in sucide prevention."
              link="https://github.com/soumyajit4419/AI_For_Social_Good"
            />
          </Col> */}

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description="Trained a CNN classifier using 'FER-2013 dataset' with Keras and tensorflow backened. The classifier sucessfully predicted the various types of emotions of human. And the highest accuracy obtained with the model was 60.1%.
              Then used Open-CV to detect the face in an image and then pass the face to the classifer to predict the emotion of a person."
              link="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
